import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { NuevoViajeRutaModelEdit} from "./items";

const CrearViajeButton = kea.defaultProps(kea.Button, { children: "Crear viaje", iconClass: fa("plus"), style:"success" });

/**Botones de creacion de movimientos de los viajes de ruta */
export class MovimientoViajeRutaIndex extends React.PureComponent {
    modalManager = kea.createModalManager();

 
    modalNuevoViaje = async () => {
        const result = await this.modalManager.showModal(NuevoViajeRutaModelEdit, undefined, {} as models.NuevoViajeRutaModel);
        if (result.result) {
            return result.value;
        } else {
            return undefined;
        }
    }

    onCrear = async () => {
        const model = await this.modalNuevoViaje();
        if (model) {
            await resources.ViajeRuta.CrearViaje(model);
        }
    }

   
    render() {
        return (
            <div>
                <div className="btn-group">
                    <CrearViajeButton onClick={this.onCrear} />
                </div>

                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/edit/index.tsx